'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import UploadIcon from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_upload.svg';
import { useTranslations } from 'next-intl';
import styles from './styles.module.scss';
import { createFileList, getLimitedFiles } from './utils';
export interface FileUploadProps {
  accept?: string;
  multiple?: boolean;
  label?: string;
  caption?: string;
  limit?: number;
  disabled?: boolean;
  className?: string;
  onFilesSelected?: (files: FileList) => Promise<void> | void;
  style?: React.CSSProperties;
  canDnD?: boolean;
}
export function FileUpload(t0) {
  const $ = _c(52);
  const {
    accept: t1,
    multiple: t2,
    label,
    caption,
    limit,
    disabled: t3,
    className,
    onFilesSelected,
    style,
    canDnD: t4
  } = t0;
  const accept = t1 === undefined ? "image/jpeg,image/png,image/webp,image/heic,image/heif,image/gif,video/mp4" : t1;
  const multiple = t2 === undefined ? true : t2;
  const disabled = t3 === undefined ? false : t3;
  const canDnD = t4 === undefined ? true : t4;
  const t = useTranslations("common");
  let t5;
  if ($[0] !== label || $[1] !== t) {
    t5 = label ?? t("fileUpload.label");
    $[0] = label;
    $[1] = t;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const resolvedLabel = t5;
  let t6;
  if ($[3] !== caption || $[4] !== t) {
    t6 = caption ?? t("fileUpload.caption");
    $[3] = caption;
    $[4] = t;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const resolvedCaption = t6;
  const inputRef = React.useRef(null);
  const [isDragActive, setIsDragActive] = React.useState(false);
  const canDropFiles = canDnD && !disabled;
  let t7;
  if ($[6] !== disabled) {
    t7 = () => {
      if (disabled) {
        return;
      }
      inputRef.current?.click();
    };
    $[6] = disabled;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const handleClick = t7;
  let t8;
  if ($[8] !== disabled || $[9] !== limit || $[10] !== multiple || $[11] !== onFilesSelected) {
    t8 = e => {
      if (disabled) {
        return;
      }
      if (e.target.files && e.target.files.length > 0) {
        const selectedFiles = getLimitedFiles(Array.from(e.target.files), multiple, limit);
        onFilesSelected?.(createFileList(selectedFiles));
        e.currentTarget.value = "";
      }
    };
    $[8] = disabled;
    $[9] = limit;
    $[10] = multiple;
    $[11] = onFilesSelected;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleChange = t8;
  let t9;
  if ($[13] !== canDropFiles || $[14] !== isDragActive) {
    t9 = e_0 => {
      if (!canDropFiles) {
        return;
      }
      e_0.preventDefault();
      e_0.stopPropagation();
      e_0.dataTransfer.dropEffect = "copy";
      if (!isDragActive) {
        setIsDragActive(true);
      }
    };
    $[13] = canDropFiles;
    $[14] = isDragActive;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const handleDragOver = t9;
  let t10;
  if ($[16] !== canDropFiles) {
    t10 = e_1 => {
      if (!canDropFiles) {
        return;
      }
      e_1.preventDefault();
      e_1.stopPropagation();
      if (!e_1.currentTarget.contains(e_1.relatedTarget as Node | null)) {
        setIsDragActive(false);
      }
    };
    $[16] = canDropFiles;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const handleDragLeave = t10;
  let t11;
  if ($[18] !== canDropFiles || $[19] !== limit || $[20] !== multiple || $[21] !== onFilesSelected) {
    t11 = e_2 => {
      if (!canDropFiles) {
        return;
      }
      e_2.preventDefault();
      e_2.stopPropagation();
      setIsDragActive(false);
      const selectedFiles_0 = getLimitedFiles(Array.from(e_2.dataTransfer.files), multiple, limit);
      if (selectedFiles_0.length === 0) {
        return;
      }
      onFilesSelected?.(createFileList(selectedFiles_0));
    };
    $[18] = canDropFiles;
    $[19] = limit;
    $[20] = multiple;
    $[21] = onFilesSelected;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const handleDrop = t11;
  const t12 = isDragActive && styles.dragActive;
  const t13 = disabled && styles.disabled;
  let t14;
  if ($[23] !== className || $[24] !== t12 || $[25] !== t13) {
    t14 = [styles.dropzone, t12, t13, className].filter(Boolean);
    $[23] = className;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = t14.join(" ");
  const t16 = disabled ? -1 : 0;
  let t17;
  if ($[27] !== disabled || $[28] !== handleClick) {
    t17 = e_3 => {
      if (disabled) {
        return;
      }
      if (e_3.key === "Enter" || e_3.key === " ") {
        e_3.preventDefault();
        handleClick();
      }
    };
    $[27] = disabled;
    $[28] = handleClick;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className={styles.icon}><UploadIcon width={20} height={20} /></div>;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== resolvedCaption || $[32] !== resolvedLabel) {
    t19 = (resolvedLabel || resolvedCaption) && <div className={styles.texts}>{resolvedLabel && <div className={styles.label}>{resolvedLabel}</div>}{resolvedCaption && <div className={styles.caption}>{resolvedCaption}</div>}</div>;
    $[31] = resolvedCaption;
    $[32] = resolvedLabel;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== accept || $[35] !== disabled || $[36] !== handleChange || $[37] !== multiple) {
    t20 = <input ref={inputRef} type="file" accept={accept} multiple={multiple} className={styles.input} onChange={handleChange} disabled={disabled} aria-hidden={true} tabIndex={-1} />;
    $[34] = accept;
    $[35] = disabled;
    $[36] = handleChange;
    $[37] = multiple;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== disabled || $[40] !== handleClick || $[41] !== handleDragLeave || $[42] !== handleDragOver || $[43] !== handleDrop || $[44] !== resolvedLabel || $[45] !== style || $[46] !== t15 || $[47] !== t16 || $[48] !== t17 || $[49] !== t19 || $[50] !== t20) {
    t21 = <div className={t15} role="button" tabIndex={t16} onClick={handleClick} onKeyDown={t17} aria-label={resolvedLabel} aria-disabled={disabled} style={style} onDragOver={handleDragOver} onDragEnter={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>{t18}{t19}{t20}</div>;
    $[39] = disabled;
    $[40] = handleClick;
    $[41] = handleDragLeave;
    $[42] = handleDragOver;
    $[43] = handleDrop;
    $[44] = resolvedLabel;
    $[45] = style;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
    $[49] = t19;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  return t21;
}
FileUpload.displayName = 'FileUpload';